export default {
  components: {
    'cys-radio': {
      path: 'cys-radio',
      name: 'cys-radio',
      title: "Radio 单选框"
    },
    'cys-checkbox': {
      path: 'cys-checkbox',
      name: 'cys-checkbox',
      title: "Checkbox 复选框"
    },
    'cys-input': {
      path: 'cys-input',
      name: 'cys-input',
      title: "Input 文本框"
    },
    'cys-textarea': {
      path: 'cys-textarea',
      name: 'cys-textarea',
      title: "Textarea 文本域"
    },
    'cys-select': {
      path: 'cys-select',
      name: 'cys-select',
      title: "Select 下拉框"
    },
    'cys-button': {
      path: 'cys-button',
      name: 'cys-button',
      title: "Button 按钮"
    },
    'cys-transition': {
      path: 'cys-transition',
      name: 'cys-transition',
      title: "Transition 动画"
    },
    'cys-layout': {
      path: 'cys-layout',
      name: 'cys-layout',
      title: "Layout 布局"
    },
    'cys-tree': {
      path: 'cys-tree',
      name: 'cys-tree',
      title: "Tree 树"
    },
    'cys-date-time': {
      path: 'cys-date-time',
      name: 'cys-date-time',
      title: "DateTime 日期时间"
    },
    'cys-modal': {
      path: 'cys-modal',
      name: 'cys-modal',
      title: "Modal 对话框"
    },
    'cys-message-box': {
      path: 'cys-message-box',
      name: 'cys-message-box',
      title: "CysMessageBox 消息窗口"
    },
    'cys-message': {
      path: 'cys-message',
      name: 'cys-message',
      title: "CysMessage 消息提示"
    },
    'cys-circle': {
      path: 'cys-circle',
      name: 'cys-circle',
      title: "CysCircle 进度环"
    },
    'cys-switch': {
      path: 'cys-switch',
      name: 'cys-switch',
      title: "Switch 开关"
    },
    'cys-avatar': {
      path: 'cys-avatar',
      name: 'cys-avatar',
      title: "CysAvatar 头像"
    },
    'cys-table': {
      path: 'cys-table',
      name: 'cys-table',
      title: "CysTable 表格"
    },
    'cys-pagination': {
      path: 'cys-pagination',
      name: 'cys-pagination',
      title: "cysPagination 分页"
    },
    'cys-form-search': {
      path: 'cys-form-search',
      name: 'cys-form-search',
      title: "CysFormSearch 搜索表单"
    },
    'cys-form': {
      path: 'cys-form',
      name: 'cys-form',
      title: "CysForm 表单"
    },
    'cys-cascader': {
      path: 'cys-cascader',
      name: 'cys-cascader',
      title: "CysCascader 联动菜单"
    },
    'cys-scrollbar': {
      path: 'cys-scrollbar',
      name: 'cys-scrollbar',
      title: "CysScrollbar 滚动条"
    }
  }
}



// WEBPACK FOOTER //
// ./examples/router/router.conf.js